import React from 'react';

class MasterChannel extends React.Component {

  render() {
    let logoUrl = 'img/channelLogos/radio2.png';
    return (
      <div className="channel">
        <img src={logoUrl} alt='' />
        <p className="hidden">
          Radio 2
        </p>
      </div>
    );
  }

}

export default MasterChannel;